export default "__VITE_ASSET__CfJPtEZ4__"